<template>
  <router-link
    class="item f-left"
    :to="{
      name: 'EbooksDetail',
      params: { id: item.id },
      query: { title: $route.query.title, recommend: $route.query.recommend },
    }"
  >
    <div class="cover-wrap">
      <img class="cover" :src="item.cover_img" />
    </div>
    <div class="right">
      <div class="title-wrap">
        <img
          class="tag"
          src="@/assets/images/common/coupon@2x.png"
          v-if="item.is_has_coupon == 1 && item.price > 0 && item.is_buy !== 1"
        />
        <img
          class="tag"
          src="@/assets/images/common/spell@2x.png"
          v-if="item.spell_id > 0 || item.is_join_spell == 1"
        />
        <span class="title">{{ item.name }}</span>
      </div>
      <div class="author introduce">作者：{{ item.author }}</div>
      <div class="introduce">{{ item.brief }}</div>
      <div class="bottom">
        <span class="sales-num">{{ item.sales_num }}人购买</span>
        <div class="has-buy" v-if="item.is_buy">已购买</div>
        <span class="f-right price-wrap" v-else>
          <strike v-if="item.underlined_price">
            <Currency type="3"></Currency>
            <span>{{ item.underlined_price | price }}</span>
          </strike>
          <span class="ebook-price" v-if="item.price">
            <Currency></Currency>
            <!-- <span>{{ item.price | price }}</span> -->
            <span>{{ privatePrice }}</span>
            <template v-if="priceDecimal > 0">
              <span class="decimal">.{{ priceDecimal }}</span>
            </template>
          </span>
          <span class="ebook-price" v-else>免费</span>
        </span>
        <!-- <CurrencyNew
          v-else
          :price="item.price"
          :priceUnderline="item.underlined_price"
          :priceTwo="true"
          :isUnderlineLeft="false"
        ></CurrencyNew> -->
      </div>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "EBooksItem",
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    privatePrice() {
      if (this.item.price) {
        let array = (this.item.price / 100).toFixed(2).toString().split(".");
        return array[0] || "";
      } else {
        return null;
      }
    },
    priceDecimal() {
      if (this.item.price) {
        let array = (this.item.price / 100).toFixed(2).toString().split(".");
        return this.getPrice(array[1]);
      } else {
        return "";
      }
    },
  },
  methods: {
    getPrice(price) {
      let newPrice = price;
      //当大于两位小数
      if (price && price.length > 2) {
        //四舍五入，保留两位小数
        let num = (this.price / 100).toFixed(2);
        newPrice = num.toString().split(".")[1];
      }
      return newPrice || "";
    },
  },
};
</script>
<style lang="scss" scoped>
.item {
  width: 384px;
  height: 202px;
  box-sizing: border-box;
  margin-bottom: 32px;
  margin-right: 24px;
  position: relative;
  border-radius: 6px;
  // border: 1px solid rgba(237, 237, 237, 1);
  background-color: white;
  display: flex;
  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);
    .cover {
      transform: scale(1.1);
    }
  }
  &:nth-child(3n) {
    margin-right: 0;
  }
  .cover-wrap {
    width: 140px;
    margin-right: 20px;
    overflow: hidden;
    flex-shrink: 0;
    border-radius: 6px 0 0 6px;
  }
  .cover {
    border-radius: 6px 0 0 6px;
    width: 100%;
    height: 100%;
    transform: scale(1);
    transition: 0.5s all;
  }
  .right {
    flex-grow: 1;
    padding-right: 24px;
    overflow: hidden;
  }
  .title-wrap {
    display: flex;
    align-items: center;
    overflow: hidden;
    margin-top: 16px;
  }
  .title {
    flex-grow: 1;
    max-width: 170px;
    font-size: 15px;
    font-weight: 500;
    color: #333;
    line-height: 24px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:hover {
      color: $primary-color;
    }
  }

  .introduce {
    height: 48px;
    font-size: 13px;
    color: #999999;
    line-height: 24px;
    // margin: 12px 0 36px 0;
    text-align: justify;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-all;
  }
  .author {
    display: block;
    line-height: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 24px;
    margin-top: 10px;
  }
  .tag {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    vertical-align: 2px;
    float: left;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 34px;
    .sales-num {
      font-size: 13px;
      color: #999999;
    }
    .price-wrap {
      display: flex;
      align-items: center;
      font-size: 13px;
    }

    strike {
      margin-right: 9px;
      display: flex;
      align-items: center;
      height: 17px;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      line-height: 17px;
      // margin-top: 11px;
    }
    .ebook-price {
      display: flex;
      align-items: center;
      height: 32px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(238, 31, 31, 1);
      line-height: 32px;
      .decimal {
        font-size: 12px;
        margin-top: 2px;
      }
    }
    .has-buy {
      font-size: 16px;
      font-weight: 600;
      color: #bb1c20;
      line-height: 22px;
    }
    // /deep/ {
    //   .price-wrap {
    //     justify-content: flex-start;
    //   }
    //   .price {
    //     margin-right: 8px;
    //     font-size: 17px;
    //     font-weight: 600;
    //   }
    //   .decimal {
    //     font-size: 12px;
    //   }
    // }
  }
}
</style>
